module.exports = __webpack_public_path__ + "c795e346f4c42161526ed8029074b8a3.png";